var app = angular.module("myApp", ['templateCacher', 'slick', 'ui.bootstrap', 'ngAnimate', 'angular-jwt', 'ngRoute', 'ngCookies', 'ngMessages', 'ngFileUpload', 'ngCookies', 'signature', 'webcam', 'pascalprecht.translate', 'angular.filter', 'ng.deviceDetector', 'imgEditor.directives', 'ng-webcam', 'ngJcrop']);

app.run(['$rootScope',
function ($rootScope) {
    

    $rootScope.GlobalAlert = function (icon, title, text) {
        return Swal.fire({
            icon: icon,
            title: title,
            text: text,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            backdrop: true,
        })
    };

    $rootScope.AlertYesNo = function (icon, title, text) {
        return Swal.fire({
            icon: icon,
            title: title,
            text: text,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            focusConfirm: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: true,
        })
    };

    $rootScope.AlertShowLoading = function (icon, title, text, timer) {
        return Swal.fire({
            icon: icon,
            title: title,
            text: text,
            timer: timer,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            onOpen: () => {
                swal.showLoading()
            }
        })
    };

    $rootScope.AlertShowFooter = function (icon, title, text, textFooter, timer) {
        return Swal.fire({
            footer: textFooter,
            icon: icon,
            title: title,
            text: text,
            timer: timer,
            showConfirmButton: false,
        })
    };
}]);

app.config(['$provide', '$routeProvider', '$locationProvider', '$translateProvider','ngJcropConfigProvider',
    function ($provide, $routeProvider, $locationProvider, $translateProvider, ngJcropConfigProvider) {
    $locationProvider.hashPrefix('');
    $routeProvider.
	when('/',
	{
	    templateUrl: 'login.html',
	    controller: 'LoginCtrl'
	}).
    when('/register',
	{
	    templateUrl: 'register.html',
	    controller: 'RegisterCtrl'
	}).
    when('/register/:id',
	{
	    templateUrl: 'register.html',
	    controller: 'RegisterCtrl'
	}).
    when('/activation/:generatedkey',
	{
	    templateUrl: 'activation.html',
	    controller: 'ActivationCtrl'
	}).
    when('/forgetpassword',
	{
	    templateUrl: 'forgetPassword.html',
	    controller: 'forgetPasswordCtrl'
	}).
    when('/change_password/:generatedkey',
	{
	    templateUrl: 'changePassword.html',
	    controller: 'changePasswordCtrl'
	}).
    when('/login',
	{
	    templateUrl: 'login.html',
	    controller: 'LoginCtrl'
	}).
     when('/cif/start',
	{
	    templateUrl: 'CIF-KTP.html',
	    controller: 'CIFKTP-CTRL'
	}).
    when('/cif/data-pribadi',
	{
	    templateUrl: 'CIF-1.html',
	    controller: 'CIF-CTRL'
	}).
    when('/cif/data-pekerjaan',
	{
	    templateUrl: 'CIF-2.html',
	    controller: 'CIF2-CTRL'
	}).
    when('/cif/data-benef',
	{
	    templateUrl: 'CIF-Benef.html',
	    controller: 'CIFBenef-CTRL'
	}).
    when('/cif/data-pendukung',
	{
	    templateUrl: 'CIF-3.html',
	    controller: 'CIF3-CTRL'
	}).
    when('/cif/data-pernyataan',
	{
	    templateUrl: 'CIF-4.html',
	    controller: 'CIF4-CTRL'
	}).
    when('/dashboard',
	{
	    templateUrl: 'dashboard/dashboard.html',
	    controller: 'CIFDashboard-CTRL'
	}).
    when('/profile',
	{
	    templateUrl: 'dashboard/profile.html',
	    controller: 'CIFProfile-CTRL'
	}).
    when('/cif/final',
	{
	    templateUrl: 'CIF-Final.html',
	    controller: 'CIFFIN-CTRL'
	}).
    when('/cif/:generatedconfirmation',
	{
	    templateUrl: 'CIF-TakenAJA.html',
	    controller: 'CIFTakenAJA-CTRL'
	}).
	otherwise(
	{
	    redirectTo: '/logout'
	});

    $translateProvider.useStaticFilesLoader({
        prefix: 'lang/locale-',
        suffix: '.json'
    });
    $translateProvider.preferredLanguage('en');
}]);

app.factory('S21Language', function () {
    var lang = '';
    return {
        getLang: function () {
            return lang;
        },

        setLang: function (value) {
            lang = value;
            return value;
        }
    };
});

app.factory('KTPCamService', function () {
    var webcam = {};
    webcam.isTurnOn = false;
    webcam.patData = null;
    var _video = null;
    var _stream = null;
    webcam.patOpts = { x: 0, y: 0, w: 25, h: 25 };
    webcam.channel = {};
    webcam.webcamError = false;

    var getVideoData = function getVideoData(x, y, w, h) {
        var hiddenCanvas = document.createElement('canvas');
        hiddenCanvas.width = _video.width;
        hiddenCanvas.height = _video.height;
        var ctx = hiddenCanvas.getContext('2d');
        ctx.drawImage(_video, 0, 0, _video.width, _video.height);
        return ctx.getImageData(x, y, w, h);
    };

    var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
        webcam.snapshotData = imgBase64;
    };

    webcam.makeSnapshot = function () {
        if (_video) {
            var patCanvas = document.querySelector('#KTPsnapshot');
            if (!patCanvas) return;

            patCanvas.width = _video.width;
            patCanvas.height = _video.height;
            var ctxPat = patCanvas.getContext('2d');

            var idata = getVideoData(webcam.patOpts.x, webcam.patOpts.y, webcam.patOpts.w, webcam.patOpts.h);
            ctxPat.putImageData(idata, 0, 0);

            sendSnapshotToServer(patCanvas.toDataURL());

            webcam.patData = idata;

            webcam.success(webcam.snapshotData.substr(webcam.snapshotData.indexOf('base64,') + 'base64,'.length), 'image/png');
            //webcam.turnOff();
        }
    };

    webcam.onSuccess = function () {
        _video = webcam.channel.video;
        webcam.patOpts.w = _video.width;
        webcam.patOpts.h = _video.height;
        webcam.isTurnOn = true;
    };

    webcam.onStream = function (stream) {
        activeStream = stream;
        console.log('kt', activeStream);
        return activeStream;
    };

    webcam.downloadSnapshot = function downloadSnapshot(dataURL) {
        window.location.href = dataURL;
    };

    webcam.onError = function (err) {
        webcam.webcamError = err;
    };

    webcam.turnOff = function () {
        webcam.isTurnOn = false;
        if (activeStream && activeStream.getVideoTracks) {
            const checker = typeof activeStream.getVideoTracks === 'function';
            if (checker) {
                console.log('ktp', activeStream.getVideoTracks());
                return activeStream.getVideoTracks()[0].stop();
            }
            return false;
        }
        return false;
    };

    var service = {
        webcam: webcam
    };
    return service;
});

app.factory('SELFIECamService', function () {
    var webcam = {};
    webcam.isTurnOn = false;
    webcam.patData = null;
    var _video = null;
    var _stream = null;
    webcam.patOpts = { x: 0, y: 0, w: 25, h: 25 };
    webcam.channel = {};
    webcam.webcamError = false;

    var getVideoData = function getVideoData(x, y, w, h) {
        var hiddenCanvas = document.createElement('canvas');
        hiddenCanvas.width = _video.width;
        hiddenCanvas.height = _video.height;
        var ctx = hiddenCanvas.getContext('2d');
        ctx.drawImage(_video, 0, 0, _video.width, _video.height);
        return ctx.getImageData(x, y, w, h);
    };

    var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
        webcam.snapshotData = imgBase64;
    };

    webcam.makeSnapshot = function () {
        if (_video) {
            var patCanvas = document.querySelector('#SELFIEsnapshot');
            if (!patCanvas) return;

            patCanvas.width = _video.width;
            patCanvas.height = _video.height;
            var ctxPat = patCanvas.getContext('2d');

            var idata = getVideoData(webcam.patOpts.x, webcam.patOpts.y, webcam.patOpts.w, webcam.patOpts.h);
            ctxPat.putImageData(idata, 0, 0);

            sendSnapshotToServer(patCanvas.toDataURL());

            webcam.patData = idata;

            webcam.success(webcam.snapshotData.substr(webcam.snapshotData.indexOf('base64,') + 'base64,'.length), 'image/png');
            //webcam.turnOff();
        }
    };

    webcam.onSuccess = function () {
        _video = webcam.channel.video;
        webcam.patOpts.w = _video.width;
        webcam.patOpts.h = _video.height;
        webcam.isTurnOn = true;
    };

    webcam.onStream = function (stream) {
        activeStream = stream;
        console.log('se', activeStream);
        return activeStream;
    };

    webcam.downloadSnapshot = function downloadSnapshot(dataURL) {
        window.location.href = dataURL;
    };

    webcam.onError = function (err) {
        webcam.webcamError = err;
        console.log('ERR', webcam.webcamError)
    };

    webcam.turnOff = function () {
        webcam.isTurnOn = false;
        if (activeStream && activeStream.getVideoTracks) {
            const checker = typeof activeStream.getVideoTracks === 'function';
            if (checker) {
                console.log('se', activeStream.getVideoTracks());
                return activeStream.getVideoTracks()[0].stop();
            }
            return false;
        }
        return false;
    };

    var service = {
        webcam: webcam
    };


    return service;
});

app.factory('SIGNATURECamService', function () {
    var webcam = {};
    webcam.isTurnOn = false;
    webcam.patData = null;
    var _video = null;
    var _stream = null;
    webcam.patOpts = { x: 0, y: 0, w: 25, h: 25 };
    webcam.channel = {};
    webcam.webcamError = false;

    var getVideoData = function getVideoData(x, y, w, h) {
        var hiddenCanvas = document.createElement('canvas');
        hiddenCanvas.width = _video.width;
        hiddenCanvas.height = _video.height;
        var ctx = hiddenCanvas.getContext('2d');
        ctx.drawImage(_video, 0, 0, _video.width, _video.height);
        return ctx.getImageData(x, y, w, h);
    };

    var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
        webcam.snapshotData = imgBase64;
    };

    webcam.makeSnapshot = function () {
        if (_video) {
            var patCanvas = document.querySelector('#SIGNATUREsnapshot');
            if (!patCanvas) return;

            patCanvas.width = _video.width;
            patCanvas.height = _video.height;
            var ctxPat = patCanvas.getContext('2d');

            var idata = getVideoData(webcam.patOpts.x, webcam.patOpts.y, webcam.patOpts.w, webcam.patOpts.h);
            ctxPat.putImageData(idata, 0, 0);

            sendSnapshotToServer(patCanvas.toDataURL());

            webcam.patData = idata;

            webcam.success(webcam.snapshotData.substr(webcam.snapshotData.indexOf('base64,') + 'base64,'.length), 'image/png');
            //webcam.turnOff();
        }
    };

    webcam.onSuccess = function () {
        _video = webcam.channel.video;
        webcam.patOpts.w = _video.width;
        webcam.patOpts.h = _video.height;
        webcam.isTurnOn = true;
    };

    webcam.onStream = function (stream) {
        activeStream = stream;
        console.log('se', activeStream);
        return activeStream;
    };

    webcam.downloadSnapshot = function downloadSnapshot(dataURL) {
        window.location.href = dataURL;
    };

    webcam.onError = function (err) {
        webcam.webcamError = err;
        console.log('ERR', webcam.webcamError)
    };

    webcam.turnOff = function () {
        webcam.isTurnOn = false;
        if (activeStream && activeStream.getVideoTracks) {
            const checker = typeof activeStream.getVideoTracks === 'function';
            if (checker) {
                console.log('se', activeStream.getVideoTracks());
                return activeStream.getVideoTracks()[0].stop();
            }
            return false;
        }
        return false;
    };

    var service = {
        webcam: webcam
    };


    return service;
});




app.controller('HomeController', ['$scope', '$rootScope', '$filter', '$http', '$window', '$q', '$cookies', '$translate', 'appFactory',
    function ($scope, $rootScope, $filter, $http, $window, $q, $cookies, $translate, appFactory) {
    $scope.login = {
        Username: '',
        Password: '',
        Email: '',
        Notelp: ''
    };

    $scope.showLogoutBtn = function () {

        var urlNow = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);
        if (urlNow == "data-pribadi" || 
            urlNow == "data-pekerjaan" || 
            urlNow == "data-pendukung" || 
            urlNow == "data-pernyataan" || 
            urlNow == "dashboard" || 
            urlNow == "profile"
            )
            return true;
        else
            return false;
    }

    $scope.languages = [
       {
           lang: 'en',
           name: 'English',
       },
       {
           lang: 'id',
           name: 'Indonesia'
       }
    ];

    $scope.languageSelected = $scope.languages[0];
    //$scope.language = 'en';

    $scope.updateLanguage = function (lang) {
        if (lang == 'id'){

            $scope.languageSelected = $scope.languages[1];
            $("#langID").addClass('bg-primary');
            $("#langEN").removeClass('bg-primary');
        } else {

            $scope.languageSelected = $scope.languages[0];
            $("#langID").removeClass('bg-primary');
            $("#langEN").addClass('bg-primary');
        }

            
        $translate.use($scope.languageSelected.lang);
        $cookies.put("lang", $scope.languageSelected.lang);
    };

    var allPromise = $q.all([

    ]);

    // trigger sign out dan kembali ke halaman login
    $scope.signOut = function () {

        appFactory.getData(`service/client.svc/SignOut`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d == true) {
                    $window.location.href = "#/";
                }
            }
        });
    };

    // dengan sweet alert confirmation dialog sebelum logout
    $scope.signOutWithConf = function () {
        
        var SWALtranslate = $scope.SWALtranslate('logoutConf');

        $rootScope.AlertYesNo('question', SWALtranslate.title, SWALtranslate.message)
        .then((result) => {
            if (result.value) {

                $scope.signOut();
            }
        });
    }

    // the dynamic post or get sweet alert 2 
    $scope.PostGetSwal = function (preconfirmtranslate, urlsvc, postData, method, callback) {

        console.log("postgetswal-urlsvc:", urlsvc)
        console.log("postgetswal-method:", method)
        console.log("postgetswal-postdata:", postData)

        var SWALtranslate = $scope.SWALtranslate(preconfirmtranslate);

        return Swal.fire({
            icon: 'question',
            title: SWALtranslate.title,
            text: SWALtranslate.message,
            showCancelButton: true,
            confirmButtonColor: '#3a3963',
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            preConfirm: (preConf) => {

                  return $http({
                    method: method,
                    url: urlsvc,
                    data: postData 
                 }).then(data => {

                     console.log(data.data.d.result)

                     if (data.data.d.result) {

                        var SWALtranslate = $scope.SWALtranslate(data.data.d.message);

                        Swal.fire({
                            title: SWALtranslate.title,
                            text: SWALtranslate.message,
                            icon: "success",
                            showConfirmButton: false,
                            timer: 3000,
                        })

                     } else {

                         var SWALtranslate = $scope.SWALtranslate(data.data.d.message);

                        Swal.fire({
                            title: SWALtranslate.title,
                            text: SWALtranslate.message,
                            icon: "error",
                            showConfirmButton: true,
                        })
                        return false;
                    }

                    callback(data.data.d.result); // send /return callback to .js
                })
                .catch(error => {
                    Swal.showValidationMessage(
                        "There is a problem connecting to the server. \
                        Please ensure your internet connection is active. If the problem persists, please try again later."
                    )
                    console.log(`Request failed: ${error}`)
                })
            }
        })
    };

    // checking halaman login,
    // jika ada session maka lanjutkan ke $scope.checkLoginStep
    $scope.checkLogin = function () {

        $http({
            method: 'POST',
            url: 'service/client.svc/retrieveSession',
        }).then(function (data) {
            if (data.data.d) {

                $scope.checkLoginStep(data.data.d);
                console.log(data.data.d)
            }
        }, function (error) { })
    }

    // req token: 
    $scope.requestToken = function () {

        $http({
            method: 'POST',
            url: 'service/client.svc/RequestToken',
            headers: {
                'Authorization': "Basic eHh4Onl5eQ=="
            }
        }).then(function (data) {


            if (data.data.d.access_token) {


                $window.localStorage.setItem('token', data.data.d.access_token)

                //$scope.checkLoginStep(data.data.d);
                //console.log(data.data.d)
            }
        }, function (error) { })
    }

    // check login step
    $scope.checkLoginStep = function (userSession) {

        // stage: finished
        if (userSession.IsFinished == 1) {
            $window.location.href = "#/dashboard";
            $window.location.reload();
        }

        // stage: 0
        if (userSession.Stage == 0) {
            $window.location.href = "#/cif/start";
            $window.location.reload();
        }

        // stage: 1
        if (userSession.Stage) {
            if (userSession.Stage == 1) {

                // stage: 1 and revised
                if (userSession.IsRevised == 1) {
                    $window.location.href = "#/dashboard";
                    $window.location.reload();
                } else {

                    $window.location.href = "#/cif/data-pribadi";
                    $window.location.reload();
                }
            }

            // stage: 2
            if (userSession.Stage == 2) {
                $window.location.href = "#/cif/data-pekerjaan";
                $window.location.reload();
            }

            // stage: 3
            if (userSession.Stage == 3) {
                $window.location.href = "#/cif/data-pekerjaan";
                $window.location.reload();
            }

            // stage: 3
            //if (userSession.Stage == 3 && (userSession.Occupation != 1 || userSession.Occupation != 2)) {
            //    $window.location.href = "#/cif/data-pendukung";
            //    $window.location.reload();
            //}

            //if (userSession.Stage == 3 && (userSession.Occupation == 1 || userSession.Occupation == 2)) {
            //    $window.location.href = "#/cif/data-benef";
            //    $window.location.reload();
            //}

            // stage: 4
            if (userSession.Stage == 4) {
                $window.location.href = "#/cif/data-pernyataan";
                $window.location.reload();

            }

            if (userSession.Stage == 5) {

                // stage: 5 and finished
                if (userSession.IsFinished == 1) {
                    $window.location.href = "#/dashboard";
                    $window.location.reload();
                } else {
                    $window.location.href = "#/cif/final";
                }

                // stage: 5 and revised
                if (userSession.IsRevised == 1) {
                    $window.location.href = "#/dashboard";
                    $window.location.reload();
                }
            }
        }
    }

    // scope untuk mengecek session saja
    // jika tidak ada session maka trigger $scope.signOut
    $scope.retrieveSessions = function () {

        $http({
            method: 'POST',
            url: 'service/client.svc/retrieveSession',
        }).then(function (data) {

            console.log(data)
            if (!data.data.d) {

                $scope.signOut();
            }
            else
                $scope.currentUser = data.data.d;

                console.log($scope.currentUser)
        }, function (error) { })
    }

    // kumpulan sweet alert translate untuk di lempar di ui sweet alert-- title, message, footer
    $scope.SWALtranslate = function (translateLocale) {

        var result = [];

        switch (translateLocale) {
            case 'logoutConf':
                
                result.title = $filter('translate')('INFO.logout');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitregistrationconf':

                result.title = $filter('translate')('INFO.submitregistration');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitregistrationsuccess':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.submitregistrationsuccess');
                break;
            case 'failed':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.emailduplicate');
                break;
            case 'savedatasuccess':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.succcessdatasave');
                break;
            case 'submitCif1':

                result.title = $filter('translate')('INFO.submitcif1');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitCif2':

                result.title = $filter('translate')('INFO.submitcif2');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitCif3':

                result.title = $filter('translate')('INFO.submitcif3');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitCif4':

                result.title = $filter('translate')('INFO.submitcif4');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'submitCif4success':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.submitcif4success');
                break;
            case 'logindisabled':

                result.title = $filter('translate')('INFO.loginfailed');
                result.message = $filter('translate')('INFO.notactivated');
                break;
            case 'notactivated':

                result.title = $filter('translate')('INFO.loginfailed');
                result.message = $filter('translate')('INFO.notactivated');
                result.footer = $filter('translate')('INFO.clicktoresendactivationlink');
                break;
            case 'wronguserpass':

                result.title = $filter('translate')('INFO.loginfailed');
                result.message = $filter('translate')('INFO.wronguserpass');
                break;
            case 'aggreement1':

                result.title = $filter('translate')('INFO.aggreement1');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'aggreement2':

                result.title = $filter('translate')('INFO.aggreement2');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'aggreement3':

                result.title = $filter('translate')('INFO.aggreement3');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'bcagagal':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.bcagagal');
                break;
            case 'forgetpasswordsuccess':

                result.title = $filter('translate')('INFO.forgetpasswordsuccess');
                result.message = $filter('translate')('INFO.checkyouremail');
                break;
            case 'changepasswordconf':

                result.title = $filter('translate')('INFO.conf');
                result.message = $filter('translate')('INFO.changepasswordconf');
                break;
            case 'changepasswordsuccess':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.changepasswordsuccess');
                break;
            case 'sendforgetpassword':

                result.title = $filter('translate')('INFO.sendchangepasswordlink');
                result.message = $filter('translate')('INFO.sureForgetPasword');
                break;
            case 'activationsuccess':

                result.title = $filter('translate')('INFO.activationsuccess');
                result.message = $filter('translate')('INFO.activationsuccessmsg');
                break;
            case 'resendactivationlink':

                result.title = $filter('translate')('INFO.resendactivationlink');
                result.message = $filter('translate')('INFO.sure');
                break;
            case 'otpsent':

                result.title = $filter('translate')('INFO.success');
                result.message = $filter('translate')('INFO.resendactivationlinksuccess');
                break;
            case 'usernotfound':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.usernotfound');
                break;
            case 'messageforgetpassword':

                result.message = $filter('translate')('INFO.succesorfailed');
                //result.message = $filter('translate')('INFO.usernotfound');
                break;
            case 'tttembed':

                result.title = "Embed Tanda Tangan";
                result.message = $filter('translate')('INFO.ttdembed');
                break;
            case 'preparationinfouploadphotocif1':

                result.title = $filter('translate')('INFO.uploadphoto');
                result.message = $filter('translate')('INFO.preparationinfouploadphoto');
                break;
            case 'validationinput':

                result.title = $filter('translate')('INFO.validinput');
                result.message = $filter('translate')('INFO.validinputmsg');
                break;
            case 'duplicatektp':

                result.title = $filter('translate')('INFO.duplicatektp');
                result.message = $filter('translate')('INFO.failed');
                break;
            case 'validatefirstname':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.firstname');
                break;
            case 'validatespousename':

                result.title = $filter('translate')('INFO.failed');
                result.message = $filter('translate')('INFO.spousename');
                break;
            case 'duplicatektp':

                result.title = $filter('translate')('INFO.duplicatektp');
                result.message = $filter('translate')('INFO.failed');
                break;
            case 'validasibenef':

                result.title = "GAGAL";
                result.message = "Wajib menggunakan data yang memiliki penghasilan";
                break;
            case 'validasixss':
                result.title = "GAGAL";
                result.message = "Format Tidak Sesuai";
            default:

                result.title = "GAGAL";
                result.message = "Data Gagal Tersimpan";
                break;
        }
        return result;
    }

    allPromise.then(function () {
        if (!$cookies.get('lang'))
            $cookies.put("lang", 'id');
        else
            $scope.updateLanguage($cookies.get('lang'));
    });
}]);

//app.directive('numericOnly', ['filter', function ($filter) {
//    return {
//        require: '?ngModel',
//        link: function (scope, elem, attrs, ctrl) {
//            if (!ctrl) {
//                return;
//            }

//            ctrl.$formatters.unshift(function () {
//                return $filter('number')(ctrl.$modelValue);
//            });

//            ctrl.$parsers.unshift(function (viewValue) {
//                var plainNumber = viewValue.replace(/[^\d]/g, ''),
//                    b = $filter('number')(plainNumber);

//                elem.val(b);
//                if (plainNumber == '') {
//                    plainNumber = 0;
//                }
//                return parseInt(plainNumber);
//            });
//        }
//    };
//}]);

app.directive('textOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {

                console.log(element)

                if (text) {

                    var transformedInput = text.replace(/[^A-Za-z\' \s]/g, '');

                    //if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    //}
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});

app.directive('numbersOnly', function () {
    return {
        require: 'ngModel',
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});

app.directive('onlyNumbers', function () {
    return {
        restrict: 'A',
        link: function (scope, elm, attrs, ctrl) {
            elm.on('keydown', function (event) {
                if (event.shiftKey) { event.preventDefault(); return false; }
                //console.log(event.which);
                if ([8, 13, 27, 37, 38, 39, 40].indexOf(event.which) > -1) {
                    // backspace, enter, escape, arrows
                    return true;
                } else if (event.which >= 48 && event.which <= 57) {
                    // numbers 0 to 9
                    return true;
                } else if (event.which >= 96 && event.which <= 105) {
                    // numpad number
                    return true;
                }
                    // else if ([110, 190].indexOf(event.which) > -1) {
                    //     // dot and numpad dot
                    //     return true;
                    // }
                else {
                    event.preventDefault();
                    return false;
                }
            });
        }
    }
});

